import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DeliveryNoteItemState } from './delivery-note-item.state';
import { SetInitialStateFacade } from '../../../../common/models';
import { DeliveryNoteItemInitialState, DeliveryNoteItemSetParams } from './delivery-note-item.actions';
import { DeliveryNoteParams } from '../models';

@Injectable({ providedIn: 'root' })
export class DeliveryNoteItemFacade implements SetInitialStateFacade {
  deliveryNoteParams$: Observable<DeliveryNoteParams> = this.store.select(DeliveryNoteItemState.getDeliveryNoteParams);

  constructor(private store: Store) {}

  setDeliveryNoteParams(params: DeliveryNoteParams): void {
    this.store.dispatch(new DeliveryNoteItemSetParams(params));
  }

  setInitialState(): void {
    this.store.dispatch(new DeliveryNoteItemInitialState());
  }
}
